<div class="spinner-overlay">
    <div class="square-spinner">
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
